module.exports = __webpack_public_path__ + "static/media/zm.71bdc28b.svg";